import { render } from "./BasicTextarea.vue?vue&type=template&id=7f48fec0&scoped=true"
import script from "./BasicTextarea.vue?vue&type=script&lang=js"
export * from "./BasicTextarea.vue?vue&type=script&lang=js"

import "./BasicTextarea.vue?vue&type=style&index=0&id=7f48fec0&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f48fec0"]])

export default __exports__